import script from "./FilterCarts.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterCarts.vue?vue&type=script&setup=true&lang=js"

import "./FilterCarts.vue?vue&type=style&index=0&id=f1f249aa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1f249aa"]])

export default __exports__